import type { NotificationInstance } from "antd/es/notification/interface";

export const copyObjectToClipboard = async (
    data: object | string,
    notification: NotificationInstance,
): Promise<void> => {
    try {
        const text =
            typeof data === "string"
                ? data
                : `\`\`\`json\n${JSON.stringify(data, null, 2)}\n\`\`\``;

        await navigator.clipboard.writeText(text);
        notification.success({
            title: "Успішно скопійовано!",
        });
    } catch (error) {
        console.error("Помилка при копіюванні:", error);
        notification.error({
            title: "Не вдалось скопіювати інформацію",
            description: String(error),
        });
    }
};
